"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const repeat_js_1 = require("lit/directives/repeat.js");
const input_styles_1 = require("@/components/common/input/input.styles");
const radio_styles_1 = require("@/components/common/radio/radio.styles");
const single_selection_controller_1 = require("@/controllers/single-selection-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/text/semantics/paragraph");
// 같은 name의 네이티브 radio가 한 shadow root에 모여야 방향키 이동과 단일 선택을 브라우저가 처리한다.
// 그래서 mm-radio를 감싸지 않고, 공유 스타일 모듈(radioStyles)을 조합해 input을 직접 렌더한다.
let RadioGroup = class RadioGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.value = '';
        this.name = '';
        this.size = 'medium';
        this.disabled = false;
        this.legend = '';
        // name을 주지 않아도 네이티브 radio가 한 그룹으로 묶이도록 내부 이름을 둔다.
        this.fallbackName = (0, utils_1.uniqueId)('radio-group');
        this.selection = new single_selection_controller_1.SingleSelectionController({
            getValue: () => this.value,
            setValue: value => {
                this.value = value;
            },
        });
    }
    render() {
        return (0, lit_1.html) `
      <fieldset ?disabled=${this.disabled}>
        <legend>${this.legend}</legend>
        ${(0, repeat_js_1.repeat)(this.options, option => option.value, option => this.renderOption(option))}
      </fieldset>
    `;
    }
    renderOption(option) {
        const inputId = `${this.fallbackName}-${option.value}`;
        return (0, lit_1.html) `
      <input
        type="radio"
        id=${inputId}
        name=${this.name || this.fallbackName}
        .value=${option.value}
        .checked=${this.selection.isOptionSelected(option)}
        ?disabled=${option.disabled}
        @change=${() => this.handleOptionChange(option)}
      />
      <label for=${inputId}>
        <span class="indicator"></span>
        <mm-paragraph>${option.label}</mm-paragraph>
      </label>
    `;
    }
    handleOptionChange(option) {
        this.selection.select(option);
        (0, utils_1.emit)(this, 'change', { value: this.value, name: this.name });
    }
};
RadioGroup.styles = [shared_styles_1.resetStyles, input_styles_1.visuallyHiddenInputStyles, input_styles_1.inputSelectionGroupStyles, radio_styles_1.radioStyles];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], RadioGroup.prototype, "options", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioGroup.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioGroup.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], RadioGroup.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], RadioGroup.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioGroup.prototype, "legend", void 0);
RadioGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-radio-group')
], RadioGroup);
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=data:application/json;base64,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